import React from 'react'
import { MDXTag } from '@mdx-js/tag'
import {CodeSurfer} from 'mdx-deck-code-surfer';
import {Helmet} from 'react-helmet';
import {dark as baseTheme} from 'mdx-deck/themes';
import codeSurfer from 'prism-react-renderer/themes/nightOwl';
import contributorsImage from './images/contributors.png';
import searchLocPragmaImage from './images/search-loc-pragma.png';
import pr7008Image from './images/pr-7008.png';
export const theme = {
  ...baseTheme,
  codeSurfer: {
    ...codeSurfer,
    showNumbers: true,
  },
};
export const meta = {
	title: 'About loc pragma',
	event: {
		name: 'crystal.tokyo #8',
		url: 'https://crystal.connpass.com/event/104912/'
	},
	date: new Date('2018-11-02T00:00:00.000Z')
}

export default [
  ({ components, ...props }) => <MDXTag name="wrapper"  components={components}>



<MDXTag name="h1" components={components}>{`About `}<MDXTag name="inlineCode" components={components} parentName="h1">{`loc`}</MDXTag>{` pragma`}</MDXTag>
<MDXTag name="h2" components={components}>{`TSUYUSATO Kitsune (@MakeNowJust)`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`About Me`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`TSUYUSATO Kitsune`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`GitHub: @MakeNowJust`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Twitter: @make_now_just`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Frontend Engineer at Space Pirates LLC.`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`No.4 Crystal Contributor`}</MDXTag>
<img src={contributorsImage} /></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`loc`}</MDXTag>{` pragma?`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`One of the hidden (undocumented) features of Crystal`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`It can update location on parsing explicitly.`}</MDXTag>
</MDXTag>
<img src={searchLocPragmaImage} /></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`Example: ECR`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`How ECR works`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`Macro `}<MDXTag name="inlineCode" components={components} parentName="li">{`ECR.def_to_s`}</MDXTag>{` calls `}<MDXTag name="inlineCode" components={components} parentName="li">{`run`}</MDXTag>{` macro with `}<MDXTag name="inlineCode" components={components} parentName="li">{`ecr/process`}</MDXTag>{` and given ECR file.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`Program `}<MDXTag name="inlineCode" components={components} parentName="li">{`ecr/process`}</MDXTag>{` prints Crystal source code generated from given ECR file.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`Then, this generated source code is embeded as a `}<MDXTag name="inlineCode" components={components} parentName="li">{`ECR.def_to_s`}</MDXTag>{` result.`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="ecr-sample.cr"
  code={require('raw-loader!./examples/ecr-sample.cr').default.trim()}
  lang="ruby"
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="ecr-sample.ecr"
  code={require('raw-loader!./examples/ecr-sample.ecr').default.trim()}
  lang="html"
  steps={[{}, {lines: [6], notes: '"tilte" is misspelled...'}]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="Execute ecr-sample.cr"
  code={require('raw-loader!./examples/ecr-sample.log').default.trim()}
  lang="text"
  steps={[
    {},
    {lines: [31, 32, 33, 34], notes: 'show correct location instead of generated code location'},
  ]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`How does ECR tell original source code location to compiler?`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`Run `}<MDXTag name="inlineCode" components={components} parentName="h2">{`ecr/process`}</MDXTag>{` at hand.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"metaString":null}}>{`\$ echo 'require "ecr/process"' |
    crystal run --stdin-filename process.cr -- ecr-sample.ecr ___io___
`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`(MEMO: the second command-line argument of `}<MDXTag name="inlineCode" components={components} parentName="p">{`ecr/process`}</MDXTag>{` means a variable name to write output.)`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="Result of ecr-sample.ecr"
  code={require('raw-loader!./examples/ecr-sample.ecr.cr').default.trim()}
  lang="ruby"
  steps={[
    {},
    {lines: [1, 3, 5], notes: 'These lines are corresponding to literal texts simply.'},
    {
      lines: [2, 4],
      notes: 'These line are corresponding to <%= ... %>, however, what is #<loc:...>?',
    },
  ]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`loc`}</MDXTag>{` pragma syntax`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:"filename",line_number,column_number>`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Override parsing location as given values.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`It looks like line comment, but it is not a comment.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`So, source code after `}<MDXTag name="inlineCode" components={components} parentName="li">{`loc`}</MDXTag>{` pragma is also parsed.`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`loc`}</MDXTag>{` pragma syntax (`}<MDXTag name="inlineCode" components={components} parentName="h2">{`push`}</MDXTag>{` and `}<MDXTag name="inlineCode" components={components} parentName="h2">{`pop`}</MDXTag>{`)`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:push>`}</MDXTag>{` and `}<MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:pop>`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:push>`}</MDXTag>{` saves current location.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:pop>`}</MDXTag>{` restores the location saved by previous `}<MDXTag name="inlineCode" components={components} parentName="li">{`#<loc:push>`}</MDXTag>{`.`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`It is useful to distinguish between macro generated code and original code.`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`Example: fix macro argument location`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="new.cr"
  code={require('raw-loader!./examples/new-1.cr').default.trim()}
  lang="ruby"
  steps={[{}, {lines: [5], notes: 'BadType is not defined of course.'}]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="Execute new.cr"
  code={require('raw-loader!./examples/new-1.log').default.trim()}
  lang="text"
  steps={[{}, {lines: [11, 12, 13], notes: 'Show macro generated code. But is it useful?'}]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="new.cr with loc pragma"
  code={require('raw-loader!./examples/new-2.cr').default.trim()}
  lang="ruby"
  steps={[{}, {lines: [2], notes: 'Build loc pragma by hand.'}]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><CodeSurfer
  title="Execute new.cr with loc pragma"
  code={require('raw-loader!./examples/new-2.log').default.trim()}
  lang="text"
  steps={[{notes: 'Then, it shows really clear error message.'}]}
/></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`If all expanded macro argument outputs its `}<MDXTag name="inlineCode" components={components} parentName="h2">{`loc`}</MDXTag>{` pragma...`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`I think it is more natural and useful.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`However `}<MDXTag name="inlineCode" components={components} parentName="li">{`loc`}</MDXTag>{` pragma is just text, so it causes some issues. e.g.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`When macro expansion appears in `}<MDXTag name="strong" components={components} parentName="li">{`doc comment`}</MDXTag>{`...`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`When macro expansion appears in `}<MDXTag name="strong" components={components} parentName="li">{`string literal`}</MDXTag>{`...`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`So, currently the compiler does not outputs `}<MDXTag name="inlineCode" components={components} parentName="p">{`loc`}</MDXTag>{` pragma for macro argument.`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`But now,`}</MDXTag>
<MDXTag name="p" components={components}>{`I created a new Pull Request with new approach.`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="a" components={components} parentName="h2" props={{"href":"https://github.com/crystal-lang/crystal/pull/7008"}}>{`crystal-lang/crystal#7008`}</MDXTag></MDXTag>
<img src={pr7008Image} />
<MDXTag name="p" components={components}>{`It does not outputs `}<MDXTag name="inlineCode" components={components} parentName="p">{`loc`}</MDXTag>{` pragma directly, but it keeps `}<MDXTag name="inlineCode" components={components} parentName="p">{`loc`}</MDXTag>{` pragmas as internal data.`}</MDXTag>
<MDXTag name="p" components={components}>{`Unfortunately it is not merged...`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h1" components={components}>{`Stay tuned ❤️`}</MDXTag></MDXTag>
]